export const RANKING_FILTER_TIER = [
	{
		name: '초보자',
		value: '0',
	},
	{
		name: '브론즈',
		value: '1',
	},
	{
		name: '실버',
		value: '2',
	},
	{
		name: '골드',
		value: '3',
	},
	{
		name: '플래티넘',
		value: '4',
	},
	{
		name: '다이아몬드',
		value: '5',
	},
	{
		name: '챌린저',
		value: '6',
	},
]

export const RANKING_FILTER_SORT_BY = [
	{
		name: '티어',
		value: '2',
	},
	{
		name: '대회 시리즈',
		value: '3',
	},
	{
		name: '매장',
		value: '4',
	},
]
